export default __webpack_public_path__ + "static/media/bodycard3.ec2b9feb.png";